class PricingRenewals {
  constructor(settings) {
    this.settings = {
      selectorSelectMenu: '#js-product-selector-wrapper',
      selectorTable: '#js-product-table-wrapper',
      selectorSubscriptionToggler: '#js-subscription-toggler-wrapper',
      selectedProduct: ['Bundles', 'DevCraft'],
      ...settings
    };

    this.settings.productSettings = {
      supportPlan: {
        name: 'Support Plan',
        type: 'support-plan',
        packages: {
          'Lite Support': ['72h response time', '10 support incidents'],
          'Priority Support': ['24h response time', 'Unlimited number of support incidents'],
          'Ultimate Support': ['24h response time', 'Unlimited number of support incidents', 'Phone support', 'Remote web assistance', 'Ticket pre-screening', 'Issue escalation']
        }
      },
      earlyRenewal: {
        name: 'Early Renewal',
        type: 'renewal',
        content: 'Before your Maintenance &amp; Support subscription plan has expired.',
        highlighted: false
      },
      lateRenewal: null,
      welcomeBackRenewal: {
        name: 'Welcome Back Renewal',
        type: 'renewal',
        content: 'When your Maintenance &amp; Support subscription plan has expired.',
        highlighted: true
      },
      subscription_Renewal: {
        name: 'Renewal',
        type: 'renewal',
        content: 'Per developer, per year',
        highlighted: true,
        subscription: true
      }
    };

    this.settings.productGroups = {
      Bundles: [
        {
          name: 'DevCraft',
          productRows: [
            {
              name: 'DevCraft UI',
              editions: [
                {
                  supportPlanVal: 'Lite',
                  earlyRenewalVal: 775,
                  welcomeBackRenewalVal: 1549,
                  subscription_RenewalVal: 1149
                }
              ]
            },
            {
              name: 'DevCraft Complete',
              editions: [
                {
                  supportPlanVal: 'Priority',
                  earlyRenewalVal: 899,
                  welcomeBackRenewalVal: 1799,
                  subscription_RenewalVal: 1299
                }
              ]
            },
            {
              name: 'DevCraft Ultimate',
              editions: [
                {
                  supportPlanVal: 'Ultimate',
                  earlyRenewalVal: 1149,
                  welcomeBackRenewalVal: 2299,
                  subscription_RenewalVal: 1649
                }
              ]
            }
          ],
          ...this.settings.productSettings
        },
        {
          name: 'Kendo UI',
          productRows: [
            {
              name: 'Kendo UI',
              editions: [
                {
                  supportPlanVal: 'Lite',
                  earlyRenewalVal: 549,
                  welcomeBackRenewalVal: 1099,
                  subscription_RenewalVal: 799
                },
                {
                  supportPlanVal: 'Priority',
                  earlyRenewalVal: 599,
                  welcomeBackRenewalVal: 1199,
                  subscription_RenewalVal: 899
                },
                {
                  supportPlanVal: 'Ultimate',
                  earlyRenewalVal: 799,
                  welcomeBackRenewalVal: 1599,
                  subscription_RenewalVal: 1299
                }
              ]
            }
          ],
          ...this.settings.productSettings
        }
      ],

      Web: [
        {
          name: 'KendoReact',
          productRows: [
            {
              name: 'KendoReact',
              editions: [
                {
                  supportPlanVal: 'Lite',
                  earlyRenewalVal: 475,
                  welcomeBackRenewalVal: 949,
                  subscription_RenewalVal: 649
                },
                {
                  supportPlanVal: 'Priority',
                  earlyRenewalVal: 525,
                  welcomeBackRenewalVal: 1049,
                  subscription_RenewalVal: 749
                },
                {
                  supportPlanVal: 'Ultimate',
                  earlyRenewalVal: 725,
                  welcomeBackRenewalVal: 1449,
                  subscription_RenewalVal: 1199
                }
              ]
            }
          ],
          ...this.settings.productSettings
        },
        {
          name: 'UI for Blazor',
          productRows: [
            {
              name: 'UI for Blazor',
              editions: [
                {
                  supportPlanVal: 'Lite',
                  earlyRenewalVal: 525,
                  welcomeBackRenewalVal: 1049,
                  subscription_RenewalVal: 749
                },
                {
                  supportPlanVal: 'Priority',
                  earlyRenewalVal: 575,
                  welcomeBackRenewalVal: 1149,
                  subscription_RenewalVal: 849
                },
                {
                  supportPlanVal: 'Ultimate',
                  earlyRenewalVal: 775,
                  welcomeBackRenewalVal: 1549,
                  subscription_RenewalVal: 1249
                }
              ]
            }
          ],
          ...this.settings.productSettings
        },
        {
          name: 'UI for ASP.NET Core',
          productRows: [
            {
              name: 'UI for ASP.NET Core',
              editions: [
                {
                  supportPlanVal: 'Lite',
                  earlyRenewalVal: 525,
                  welcomeBackRenewalVal: 1049,
                  subscription_RenewalVal: 749
                },
                {
                  supportPlanVal: 'Priority',
                  earlyRenewalVal: 575,
                  welcomeBackRenewalVal: 1149,
                  subscription_RenewalVal: 849
                },
                {
                  supportPlanVal: 'Ultimate',
                  earlyRenewalVal: 775,
                  welcomeBackRenewalVal: 1549,
                  subscription_RenewalVal: 1249
                }
              ]
            }
          ],
          ...this.settings.productSettings
        },
        {
          name: 'UI for ASP.NET MVC',
          productRows: [
            {
              name: 'UI for ASP.NET MVC',
              editions: [
                {
                  supportPlanVal: 'Lite',
                  earlyRenewalVal: 525,
                  welcomeBackRenewalVal: 1049,
                  subscription_RenewalVal: 749
                },
                {
                  supportPlanVal: 'Priority',
                  earlyRenewalVal: 575,
                  welcomeBackRenewalVal: 1149,
                  subscription_RenewalVal: 849
                },
                {
                  supportPlanVal: 'Ultimate',
                  earlyRenewalVal: 775,
                  welcomeBackRenewalVal: 1549,
                  subscription_RenewalVal: 1249
                }
              ]
            }
          ],
          ...this.settings.productSettings
        },
        {
          name: 'UI for ASP.NET AJAX',
          productRows: [
            {
              name: 'UI for ASP.NET AJAX',
              editions: [
                {
                  supportPlanVal: 'Lite',
                  earlyRenewalVal: 525,
                  welcomeBackRenewalVal: 1049,
                  subscription_RenewalVal: 749
                },
                {
                  supportPlanVal: 'Priority',
                  earlyRenewalVal: 575,
                  welcomeBackRenewalVal: 1149,
                  subscription_RenewalVal: 849
                },
                {
                  supportPlanVal: 'Ultimate',
                  earlyRenewalVal: 775,
                  welcomeBackRenewalVal: 1549,
                  subscription_RenewalVal: 1249
                }
              ]
            }
          ],
          ...this.settings.productSettings
        }
      ],

      Mobile: [
        {
          name: 'UI for .NET MAUI',
          productRows: [
            {
              name: 'UI for .NET MAUI',
              editions: [
                {
                  supportPlanVal: 'Lite',
                  earlyRenewalVal: 525,
                  welcomeBackRenewalVal: 1049,
                  subscription_RenewalVal: 749
                },
                {
                  supportPlanVal: 'Priority',
                  earlyRenewalVal: 575,
                  welcomeBackRenewalVal: 1149,
                  subscription_RenewalVal: 849
                },
                {
                  supportPlanVal: 'Ultimate',
                  earlyRenewalVal: 775,
                  welcomeBackRenewalVal: 1549,
                  subscription_RenewalVal: 1249
                }
              ]
            }
          ],
          ...this.settings.productSettings
        }
      ],

      Desktop: [
        {
          name: 'UI for .NET MAUI',
          productRows: [
            {
              name: 'UI for .NET MAUI',
              editions: [
                {
                  supportPlanVal: 'Lite',
                  earlyRenewalVal: 525,
                  welcomeBackRenewalVal: 1049,
                  subscription_RenewalVal: 749
                },
                {
                  supportPlanVal: 'Priority',
                  earlyRenewalVal: 575,
                  welcomeBackRenewalVal: 1149,
                  subscription_RenewalVal: 849
                },
                {
                  supportPlanVal: 'Ultimate',
                  earlyRenewalVal: 775,
                  welcomeBackRenewalVal: 1549,
                  subscription_RenewalVal: 1249
                }
              ]
            }
          ],
          ...this.settings.productSettings
        },
        {
          name: 'UI for WinForms',
          productRows: [
            {
              name: 'UI for WinForms',
              editions: [
                {
                  supportPlanVal: 'Lite',
                  earlyRenewalVal: 525,
                  welcomeBackRenewalVal: 1049,
                  subscription_RenewalVal: 749
                },
                {
                  supportPlanVal: 'Priority',
                  earlyRenewalVal: 575,
                  welcomeBackRenewalVal: 1149,
                  subscription_RenewalVal: 849
                },
                {
                  supportPlanVal: 'Ultimate',
                  earlyRenewalVal: 775,
                  welcomeBackRenewalVal: 1549,
                  subscription_RenewalVal: 1249
                }
              ]
            }
          ],
          ...this.settings.productSettings
        },
        {
          name: 'UI for WPF',
          productRows: [
            {
              name: 'UI for WPF',
              editions: [
                {
                  supportPlanVal: 'Lite',
                  earlyRenewalVal: 525,
                  welcomeBackRenewalVal: 1049,
                  subscription_RenewalVal: 749
                },
                {
                  supportPlanVal: 'Priority',
                  earlyRenewalVal: 575,
                  welcomeBackRenewalVal: 1149,
                  subscription_RenewalVal: 849
                },
                {
                  supportPlanVal: 'Ultimate',
                  earlyRenewalVal: 775,
                  welcomeBackRenewalVal: 1549,
                  subscription_RenewalVal: 1249
                }
              ]
            }
          ],
          ...this.settings.productSettings
        }
      ],

      'Reporting and Mocking': [
        {
          name: 'Telerik Reporting',
          productRows: [
            {
              name: 'Telerik Reporting',
              editions: [
                {
                  supportPlanVal: 'Lite',
                  earlyRenewalVal: 375,
                  welcomeBackRenewalVal: 749,
                  subscription_RenewalVal: 499
                },
                {
                  supportPlanVal: 'Priority',
                  earlyRenewalVal: 425,
                  welcomeBackRenewalVal: 849,
                  subscription_RenewalVal: 599
                },
                {
                  supportPlanVal: 'Ultimate',
                  earlyRenewalVal: 625,
                  welcomeBackRenewalVal: 1249,
                  subscription_RenewalVal: 999
                }
              ]
            }
          ],
          ...this.settings.productSettings
        },
        {
          name: 'Telerik Report Server',
          productRows: [
            {
              name: 'Telerik Report Server',
              editions: [
                {
                  supportPlanVal: 'Lite',
                  earlyRenewalVal: 775,
                  welcomeBackRenewalVal: 1549,
                  subscription_RenewalVal: 1099
                },
                {
                  supportPlanVal: 'Priority',
                  earlyRenewalVal: 825,
                  welcomeBackRenewalVal: 1649,
                  subscription_RenewalVal: 1199
                },
                {
                  supportPlanVal: 'Ultimate',
                  earlyRenewalVal: 1025,
                  welcomeBackRenewalVal: 2049,
                  subscription_RenewalVal: 1599
                }
              ]
            }
          ],
          ...this.settings.productSettings
        },
        {
          name: 'Telerik JustMock',
          productRows: [
            {
              name: 'Telerik JustMock',
              editions: [
                {
                  supportPlanVal: 'Lite',
                  earlyRenewalVal: 249,
                  welcomeBackRenewalVal: 499,
                  subscription_RenewalVal: 349
                },
                {
                  supportPlanVal: 'Priority',
                  earlyRenewalVal: 299,
                  welcomeBackRenewalVal: 599,
                  subscription_RenewalVal: 449
                },
                {
                  supportPlanVal: 'Ultimate',
                  earlyRenewalVal: 499,
                  welcomeBackRenewalVal: 999,
                  subscription_RenewalVal: 849
                }
              ]
            }
          ],
          ...this.settings.productSettings
        }
      ],

      'Automated Testing': [
        {
          name: 'Test Studio',
          hideSubscription: true,
          productRows: [
            {
              name: 'Test Studio Web & Desktop',
              editions: [
                {
                  supportPlanVal: 'Priority',
                  earlyRenewalVal: 1249,
                  lateRenewalVal: 1629,
                  welcomeBackRenewalVal: 2249
                }
              ]
            },
            {
              name: 'Test Studio Load',
              editions: [
                {
                  supportPlanVal: 'Priority',
                  earlyRenewalVal: 499,
                  lateRenewalVal: 649,
                  welcomeBackRenewalVal: 899
                }
              ]
            },
            {
              name: 'Test Studio Ultimate',
              editions: [
                {
                  supportPlanVal: 'Priority',
                  earlyRenewalVal: 1749,
                  lateRenewalVal: 2269,
                  welcomeBackRenewalVal: 2699
                }
              ]
            },
            {
              name: 'Test Studio Runtime',
              editions: [
                {
                  supportPlanVal: 'N/A',
                  earlyRenewalVal: 179,
                  lateRenewalVal: 229,
                  welcomeBackRenewalVal: 319
                }
              ]
            },
            {
              name: 'Test Studio Runtime Unlimited',
              editions: [
                {
                  supportPlanVal: 'N/A',
                  earlyRenewalVal: 3249,
                  lateRenewalVal: 4219,
                  welcomeBackRenewalVal: 5199
                }
              ]
            },
            {
              name: 'Test Studio Virtual Users - 100',
              editions: [
                {
                  supportPlanVal: 'N/A',
                  earlyRenewalVal: 449,
                  lateRenewalVal: 589,
                  welcomeBackRenewalVal: 809
                }
              ]
            },
            {
              name: 'Test Studio Virtual Users - 1,000',
              editions: [
                {
                  supportPlanVal: 'N/A',
                  earlyRenewalVal: 1499,
                  lateRenewalVal: 1949,
                  welcomeBackRenewalVal: 2699
                }
              ]
            },
            {
              name: 'Test Studio Virtual Users - 10,000',
              editions: [
                {
                  supportPlanVal: 'N/A',
                  earlyRenewalVal: 2499,
                  lateRenewalVal: 3249,
                  welcomeBackRenewalVal: 4499
                }
              ]
            }
          ],
          ...this.settings.productSettings,
          lateRenewal: {
            name: 'Late Renewal',
            type: 'renewal',
            content: 'Up to 60 days after your maintenance & support subscription plan has expired.',
            highlighted: false,
            specificFor: 'Test Studio'
          },
          welcomeBackRenewal: {
            name: 'Welcome Back Renewal',
            type: 'renewal',
            content: 'When your maintenance &amp; support subscription plan has been expired for more than 60 days.',
            highlighted: true,
            specificFor: 'Test Studio'
          }
        }
      ]
    };

    this.renewalPlans = [];
    this.displaySubscriptionPrices = false;
    [this.settings.preselectedGroup, this.settings.preselectedProduct] = this.settings.selectedProduct;

    this.init();
  }

  init() {
    if (!document.querySelector(this.settings.selectorSelectMenu) || !document.querySelector(this.settings.selectorTable)) {
      throw new Error('PricingRenewals Plugin >>> missing DOM elements for select menu or table wrapper');
    }
    this.createProductSelector();
    this.createSubscriptionSelector();
    PricingRenewals.changeSelectedProduct(
      this.settings.preselectedGroup,
      this.settings.preselectedProduct,
      this.settings.selectorSelectMenu
    );
  }

  static createTooltip(packages) {
    let tooltipHTML = '';
    Object.entries(packages).forEach(([supportType, supportFeatures]) => {
      tooltipHTML += `<div class="RenewalTooltip-title">${supportType}</div>`;
      supportFeatures.forEach(feature => {
        tooltipHTML += `<div>${feature}</div>`;
      });
    });
    return tooltipHTML;
  }

  static formatPrice(price, after = '', ifEmpty = '') {
    return price ? `$${price.toLocaleString()}${after}` : ifEmpty;
  }

  static changeSelectedProduct(group, product, selectWrap) {
    const selector = document.querySelector(`${selectWrap} select`);
    let newSelectedIndex;
    if (!product || !group) {
      newSelectedIndex = 0;
    }
    else {
      selector.querySelectorAll(`option[data-group="${group}"]`).forEach(option => {
        newSelectedIndex = option.innerText === product ? option.index : newSelectedIndex;
      });
    }
    selector.selectedIndex = newSelectedIndex;
    selector.dispatchEvent(new Event('change'));
  }

  createTable(data) {
    const subscription = this.displaySubscriptionPrices;
    const tableWrap = document.createElement('div');
    tableWrap.classList.add('TableWrap');
    const table = document.createElement('table');
    table.classList.add('Table', 'Table--pricelist');
    if (data.lateRenewal) table.classList.add('Table--pricelistFull');

    const thead = document.createElement('thead');

    // THEAD CONTENT
    const th1 = `<th>${data.name} Editions</th>`;
    const th2 = `
      <th class="Table--pricelist-plan">
        <div class="Tooltip--text RenewalTooltip">
          ${data.supportPlan.name}
          <div class="Tooltip">?
            <div class="Tooltip-info Tooltip-info--left">
              ${PricingRenewals.createTooltip(data.supportPlan.packages)}
            </div>
          </div>
        </div>
      </th>
    `;
    let th_ = '';
    Object.values(data).filter(renewal => renewal && renewal.type === 'renewal').forEach(renewal => {
      if ((subscription && renewal.subscription) || (!subscription && !renewal.subscription)) {
        th_ += `
          <th>
            ${renewal.name}
            <div class="Table--pricelist-desc ${renewal.highlighted ? 'Table--pricelist-highlighted' : ''}">
              ${renewal.content}
            </div>
          </th>
        `;
        if (this.renewalPlans.indexOf(renewal) < 0) this.renewalPlans.push(renewal);
      }
    });

    thead.innerHTML = `<tr>${th1}${th2}${th_}</tr>`;
    table.append(thead);

    // TBODY CONTENT
    let rowContent = '';
    data.productRows.forEach(productRow => {
      const editionsCount = productRow.editions.length;
      const tbody = document.createElement('tbody');
      productRow.editions.forEach((edition, i) => {
        rowContent += `<tr ${i === 0 ? `>
        <td rowspan="${editionsCount}">${productRow.name}</td>` : 'class="is-row-spanned" >'}
        <td>${edition.supportPlanVal}</td>`;
        Object.keys(edition).forEach(renewalPlan => {
          if (renewalPlan === 'supportPlanVal') return;
          if (subscription && renewalPlan.indexOf('subscription_') < 0) return;
          if (!subscription && renewalPlan.indexOf('subscription_') === 0) return;
          rowContent += `<td>${PricingRenewals.formatPrice(edition[renewalPlan])}</td>`;
        });
        rowContent += '</tr>';
      });
      tbody.innerHTML = rowContent;
      rowContent = '';
      table.append(tbody);
    });

    // LITE TABLE (Generating alternative responsive table for mobile)
    const liteTable = document.createElement('table');
    liteTable.classList.add('Table', 'Table--pricelist', 'LiteTable');

    let editionRows = `<thead><tr><th colspan="2">${data.name} Editions</th></tr></thead><tbody>`;

    data.productRows.forEach(productRow => {
      productRow.editions.forEach(edition => {
        editionRows += `
          <tr class="LiteTable-head">
            <td colspan="2">
              <div class="LiteTable-edition">${productRow.name}</div>
              <div class="LiteTable-plan">
                <div class="Tooltip--text RenewalTooltip">
                  with ${edition.supportPlanVal} ${data.supportPlan.name}
                  <div class="Tooltip">?
                    <div class="Tooltip-info Tooltip-info--left">
                      ${PricingRenewals.createTooltip(data.supportPlan.packages)}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        `;
        let availableRenewals = -1;
        Object.keys(edition).forEach(renewalPlan => {
          if (renewalPlan === 'supportPlanVal') return;
          if (subscription && renewalPlan.indexOf('subscription_') < 0) return;
          if (!subscription && renewalPlan.indexOf('subscription_') === 0) return;
          availableRenewals++;
          editionRows += `
            <tr class="LiteTable-${renewalPlan}">
              <td>
                <div class="LiteTable-action-desc">
                  ${this.renewalPlans[availableRenewals].name}
                  ${this.displaySubscriptionPrices ? this.renewalPlans[availableRenewals].content.toLowerCase() : '<sup>*</sup>'}
                </div>
              </td>
              <td>${PricingRenewals.formatPrice(edition[renewalPlan])}</td>
            </tr>
          `;
        });
      });
    });

    editionRows += '</tbody>';
    liteTable.innerHTML = editionRows;

    // CONSTRUCT THE TABLES
    tableWrap.append(table, liteTable);
    return tableWrap;
  }

  changeLicenseType(licenseType = null) {
    // this method changes the selected license type without dispatching a change event on the product selector
    // useful when selected product has `hideSubscription == true` and we need to hide the subscription switcher
    // and enforce the only available `perpetual` license type /example product: Test Studio/
    const switchBtn = document.querySelector(`${this.settings.selectorSubscriptionToggler} .Switch--toggleMode`);
    const currentLicenseType = this.displaySubscriptionPrices ? 'subscription' : 'perpetual';

    let desiredLicenseType = licenseType;
    if (!desiredLicenseType) desiredLicenseType = currentLicenseType === 'subscription' ? 'perpetual' : 'subscription';
    if (desiredLicenseType === currentLicenseType) return;

    this.displaySubscriptionPrices = desiredLicenseType === 'subscription';
    desiredLicenseType === 'perpetual' ? switchBtn.classList.add('is-active') : switchBtn.classList.remove('is-active');

    Array.from(switchBtn.children).filter(el => el.dataset.type).forEach(btn => {
      btn.dataset.type === desiredLicenseType ? btn.classList.add('is-active') : btn.classList.remove('is-active');
    });
  }

  selectProductHandler(e) {
    this.renewalPlans = [];
    const product = e.target.value;
    const { dataset: { group } } = e.target.options[e.target.selectedIndex];
    const tableWrapper = document.querySelector(this.settings.selectorTable);
    const subscriptionSwitcher = document.querySelector(this.settings.selectorSubscriptionToggler).parentElement;

    tableWrapper.innerHTML = '';

    if (product === 'View All') {
      Object.values(this.settings.productGroups).forEach(bundle => {
        bundle.forEach(productData => {
          if (this.displaySubscriptionPrices && productData.hideSubscription) return;
          tableWrapper.append(this.createTable(productData));
        });
      });
      subscriptionSwitcher.hidden = false;
    }
    else {
      const productData = this.settings.productGroups[group].find(prod => prod.name === product);
      if (productData.hideSubscription) {
        subscriptionSwitcher.hidden = true;
        if (this.displaySubscriptionPrices) this.changeLicenseType('perpetual');
      }
      else {
        subscriptionSwitcher.hidden = false;
      }
      tableWrapper.append(this.createTable(productData));
    }

    // Add asterisk hints at the bottom for the lite version
    if (!this.displaySubscriptionPrices) {
      const hintsTable = document.createElement('table');
      hintsTable.classList.add('Table', 'Table--pricelist', 'LiteTable', 'LiteTable--hints');
      let renewalPlansHints = '';
      this.renewalPlans.forEach(renewalPlan => {
        renewalPlansHints += `
          <dt>${renewalPlan.name} ${product === 'View All' && renewalPlan.specificFor ? `(${renewalPlan.specificFor})` : ''}</dt>
          <dd>${renewalPlan.content}</dd>
        `;
      });
      hintsTable.innerHTML = `
        <tr>
          <td colspan="2">
            <div class="LiteTable-hint-name">* Renewals:</div>
            <div class="LiteTable-hint-desc">
              <dl>
                ${renewalPlansHints}
              </dl>
            </div>
          </td>
        </tr>
      `;
      tableWrapper.append(hintsTable);
    }
  }

  createProductSelector() {
    if (!this.settings.productGroups) {
      throw new Error('PricingRenewals plugin >>> missing productGroups object containing product information');
    }

    const selector = document.createElement('select');
    const optionAll = document.createElement('option');
    optionAll.innerText = 'View All';
    selector.append(optionAll);

    Object.entries(this.settings.productGroups).forEach(([group, products]) => {
      const optgroup = document.createElement('optgroup');
      optgroup.setAttribute('label', group);

      products.forEach(product => {
        const option = document.createElement('option');
        option.innerText = product.name;
        option.dataset.group = group;
        optgroup.append(option);
      });

      selector.append(optgroup);
    });
    document.querySelector(this.settings.selectorSelectMenu).append(selector);
    selector.setAttribute('aria-label', 'select product');
    selector.addEventListener('change', this.selectProductHandler.bind(this));
    return true;
  }

  createSubscriptionSelector() {
    const toggler = document.createElement('button');
    toggler.classList.add('Switch', 'Switch--toggleMode');
    toggler.dataset.tlrkPlugin = 'toggle';
    toggler.dataset.toggle = '.js-renewalToggler, .Switch--toggleMode';
    toggler.dataset.toggleClassName = 'is-active';
    toggler.innerHTML = `
      <span class="Switch-label js-renewalToggler u-pen is-active" data-type="subscription">Subscription</span>
      <span class="Switch-btn u-pen"></span>
      <span class="Switch-label js-renewalToggler" data-type="perpetual">
        <span class="Tooltip--text RenewalTooltip">
          Perpetual
          <span class="Tooltip">?
            <span class="Tooltip-info u-pen u-ttn">
              Perpetual licenses are no longer available for online purchase, but existing customers can continue renewing their maintenance and support.
            </span>
          </span>
        </span>
      </span>
    `;
    document.querySelector(this.settings.selectorSubscriptionToggler).append(toggler);
    toggler.addEventListener('change', e => {
      const activeToggler = e.toggleTargets.find(el => el.dataset.type && el.classList.contains('is-active'));
      this.displaySubscriptionPrices = activeToggler.dataset.type === 'subscription';
      document.querySelector(`${this.settings.selectorSelectMenu} select`).dispatchEvent(new Event('change'));
    });
    this.displaySubscriptionPrices = toggler.querySelector('.js-renewalToggler.is-active').dataset.type === 'subscription';
  }
}

window.PricingRenewals = PricingRenewals;
